type CheckedChangeEvent = { detail?: { checked?: boolean } } | null | undefined;

/**
 * Builds a PrismCheckbox `onPrismChange` handler that only fires for a real change.
 *
 * Prism 9's checkbox re-emits prismChange whenever its `checked` prop changes, including
 * when React sets it. A handler that blindly toggles state therefore re-toggles on every
 * echo until React hits "Maximum update depth exceeded" and unmounts the tree. Comparing
 * `detail.checked` with the current value turns that echo into a no-op.
 */
export function onCheckedChange(
  current: boolean,
  apply: (checked: boolean) => void
): (e: CheckedChangeEvent) => void {
  return (e) => {
    const reported = e?.detail?.checked;
    const next = typeof reported === 'boolean' ? reported : !current;
    if (next !== current) apply(next);
  };
}
